import React from 'react';
import { useParams } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Tab, Tabs } from "@curves/ui-base";
import { CLUB_DOCUMENTS_ROUTER } from '@icoach/router/routerPath';
import { TRANSFEROUT_MOVETYPE } from '@icoach/constants/';

const MembershipTransferOutSearchBarTabs = props => {
	const { moveoutType } = useParams();

	return (
		<Tabs className="pl-2" value={moveoutType} variant="scrollable" allowScrollButtonsMobile>
			<Tab className="pt-3" label="未移出" component={NavLink} value={TRANSFEROUT_MOVETYPE.UNMOVEOUT} to={CLUB_DOCUMENTS_ROUTER.TRANSFEROUT.GET_MOVEOUTTYPE_PATH(TRANSFEROUT_MOVETYPE.UNMOVEOUT)} />
			<Tab className="pt-3" label="已移出" component={NavLink} value={TRANSFEROUT_MOVETYPE.MOVEOUT} to={CLUB_DOCUMENTS_ROUTER.TRANSFEROUT.GET_MOVEOUTTYPE_PATH(TRANSFEROUT_MOVETYPE.MOVEOUT)} />
		</Tabs>
	);
};

export default MembershipTransferOutSearchBarTabs;
